import axios from "@/request";
import qs from "qs";

export default {
  async reportList(params: any) {
    return axios.get("bi/accountreport/list", { params });
  },
  async reportDetail(params: any) {
    return axios.get("bi/accountreport/detail-list", { params });
  },
  async reportDetailExport(params: any) {
    return axios.get("bi/accountreport/detail-export", {
      params,
      responseType: "blob"
    });
  },
  async rowDetailList(params: any) {
    return axios.get("bi/accountreport/row-detail-list", { params });
  },
  async exportRowDetailList(params: any) {
    return axios.get("bi/accountreport/export-row-detail-list", { params, responseType: "blob" });
  },
  async excelBalance(params: any) {
    return axios.get("bi/statistics-excel/balance", { params });
  },
  async excelRefund(params: any) {
    return axios.get("bi/statistics-excel/refund", { params });
  },
  async excelIncome(params: any) {
    if (+params.is_export > 0 && params.blob) {
      return axios.get("bi/statistics-excel/income", { params ,responseType: "blob"});
    }
    return axios.get("bi/statistics-excel/income", { params });
  },
  async excelExpire(params: any) {
    if(+params.is_export>0){
      return axios.get("bi/statistics-excel/expire", { params ,responseType: "blob"});
    }
    return axios.get("bi/statistics-excel/expire", { params });
  },
  async settlement(params: any){
    return axios.get('bi/statistics-excel/settlement',{params});
  },
};
